export const noteDefaultFieldStyles = {
  group: 'flex flex-wrap gap-2',
  option:
    'flex cursor-pointer items-center gap-2 rounded-lg border bg-white px-3 py-2 text-sm transition-colors hover:bg-slate-50',
};
